module.exports = __webpack_public_path__ + "img/Recorder-New.e3003335.gif";